<template>
<div class="taxt-calculator">
  <div v-if="isCalculator">
  <h2>Use our tax deduction calculator to estimate your savings <span class="wwf-tooltip"><p>This table is based upon 2017-2018 ATO individual Income Tax rates. The above rates do not include the Medicare Levy of 2%. The exact level of your tax deductibility will vary depending on your present financial circumstances. Please seek assistance from an independent taxation professional for formal guidelines.</p></span></h2>
  			<input autocomplete="off" @focus="setShowResult(false)" type="tel" name="amount" id="amount" v-validate="{required: true, checkifvalid: true, regex: /^\d+(\.\d{1,2})?$/}" v-model="amount" :class="{'border-red': errors.has('amount')}" placeholder="Donation amount" data-vv-as="amount">
  <span class="wwf-alert"><p v-if="errors.first('amount')">{{errors.first('amount')}}</p></span>
  <input type="button" @click="calculate" value="Calculate">
  </div>
  <div v-if="!isCalculator || isShowResult">
  <h2>How much tax does that save you?</h2>
   <table class="tg" >
 <tbody><tr>
   <th class="tg-yw4l">Income</th>
   <th class="tg-yw4l">Savings</th>
 </tr>
 <tr v-for="tax in getTaxBrackeList">
   <td class="tg-yw4l">{{tax.bracket}}</td>
   <td class="tg-yw4l">{{(amount * tax.tax).toFixed(2)}}</td>
 </tr>
</tbody></table>
<a href="#/" v-on:click="donate" class="bttn-lrg-arrw" v-if="isCalculator">Donate ${{(amount && amount.indexOf('.00') >= 0) ? amount.slice(0,-3) : amount}}</a>
</div>
</div>


</template>

<script>
import { getTaxBrackeList } from "../helpers";

export default {
  name: "my-taxCalculator",
  props: {
    amount: {
      // Attribute for the productID
      type: String,
      required: false,
      default: null
    }
  },
  created: function() {
    console.log("created", this.amount);
    if (this.amount) {
      this.isCalculator = false;
    }
  },
  data() {
    return {
      //amount: null,
      income: "",
      saving: null,
      pay: null,
      getTaxBrackeList: getTaxBrackeList(),
      isShowResult: false,
      isCalculator: true
    };
  },
  methods: {
    calculate: function() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          console.log("The form on step1 product is invalid");
          //reject("The form on step1 product is invalid");
        } else {
          this.setShowResult(true);
        }
      });
    },
    setShowResult: function(value) {
      this.isShowResult = value;
    },
        donate: function () {
          if (window.dataLayer != undefined) { window.dataLayer.push({ 'formName': 'taxcalculator', 'event': 'formSubmitSuccessEvent' }); }

          window.open(wwfconfigs.DONATEURL + '/donate/one-off-donation/tax-2018' + '?q='+window.btoa('dollarhandle=custom&amount='+this.amount),"_blank")
      }
  }
};
</script>

<style scoped>

/* TAX CALCULATOR */

.wwf-form table {
  font-size: 14px;
  text-align: left;
}

.wwf-form table tbody tr:nth-child(even) {
  border-bottom: 0;
  background-color: var(--wwfGreyDF);
}
</style>


// WEBPACK FOOTER //
// TaxCalculator.vue?099c653a